<template>
  <div class="dialog-body-content-base-style">
    <video-player
      class="video-player vjs-custom-skin"
      ref="videoPlayer"
      :playsinline="true"
      :options="playerOptions"
      @play="onPlayerPlay($event)"
      @pause="onPlayerPause($event)"
    ></video-player>
  </div>
</template>
<script>
import { videoPlayer } from "vue-video-player";
import "vue-video-player/src/custom-theme.css";
import "video.js/dist/video-js.css";

export default {
  name: "detailPlayer",
  components: {
    videoPlayer
  },
  /* props: {
    //播放源地址参数
    url: {
      type: String,
      default: ""
    }
  }, */
  data() {
    return {
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度选择
        autoplay: true, //如果true,浏览器准备好时开始回放。
        muted: true, // 默认情况下将会消除任何音频。
        fluid: true, // 当true时，将按比例缩放以适应其容器。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        sources: [
          {
            type: "video/mp4", //格式
            src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4" //视频地址（必填）
          }
        ],
        poster: "http://pic33.nipic.com/20131007/13639685_123501617185_2.jpg", //你的封面地址
        // width: 400, //document.documentElement.clientWidth 播放器宽度
        // height: 400, //document.documentElement.clientHeight 播放器高度
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          currentTimeDisplay: true, // 当前时间
          remainingTimeDisplay: true, //是否显示剩余时间功能
          fullscreenToggle: true, //是否显示全屏按钮
          volumeControl: false, // 声音控制键
          playToggle: true, // 暂停和播放键
          progressControl: true // 进度条
        }
      }
    };
  },
  mounted() {
    // this.changeVideoSrc();
  },
  methods: {
    //响应式改变播放源地址
    changeVideoSrc() {
      this.playerOptions.sources[0]["src"] =
        "https://www.liujie006.cn/" + this.url;
    },
    //播放回调
    onPlayerPlay(player) {
      console.log("play");
    },
    //暂停回调
    onPlayerPause(player) {
      console.log("pause");
    }
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    }
  }
};
</script>
<style lang="less" scoped>
// 调整播放器样式
.video-js .vjs-icon-placeholder {
  width: 100%;
  height: 100%;
  display: block;
}
video {
  width: 100% !important;
  height: calc(100vh - 95px) !important;
  object-fit: fill; //消除留白
}
.container {
  background-color: #efefef;
  min-height: 100%;
  .player {
    height: 100%;
  }
  .video-player,
  #vjs_video_3,
  .video-js.vjs-fluid,
  .video-js.vjs-16-9,
  .video-js.vjs-4-3 {
    height: 100% !important;
  }
}
</style>